export const inspirationDetailsPagePath = '/inspirations/details/:slug';

export const getInspriationDetailsPageUrl = (slug: string) => {
  return inspirationDetailsPagePath.replace(':slug', slug);
};